export default __webpack_public_path__ + "static/graphik-web-light-a46bb0927fdb95948f7b26cf584271d2.woff";